import React from "react";
import { FaMoneyBillAlt } from "react-icons/fa";
class Banking extends React.Component {
  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaMoneyBillAlt className="c-placeholder c-green" />,
      Title: "Bankovní technika",
      SubTitle: "",
    });
  }
  render() {
    return (
      <p class="text-left">
        Naše společnost zajišťuje servis bankovní techniky značek
        <br />
        <br />
        <strong>Brandt</strong> (počítačky bankovek a počítačky mincí)
        <br />
        <strong>De La Rue</strong> (počítačky bankovek a počítačky mincí)
        <br />
        <strong>Nixdorf</strong> (dokladové tiskárny řady 4915)
        <br />
        <strong>verifikátory</strong> (detektory pravosti bankovek různých
        značek)
        <br />
      </p>
    );
  }
}

export default Banking;
